import i18n from 'i18next'

import UsersApi from '../api/UsersApi'
import { User } from '../utils/userHelpers'
import mst from '../store/models'

export function verifyUniqueEmail(formData) {
  return UsersApi.verifyUniqueEmail(formData)
    .then((res) => {
      if (res.response.ok) {
        return
      } else {
        // eslint-disable-next-line
        throw { email: [i18n.t('auth.emailTaken')] }
      }
    })
    .catch((error) => {
      throw error
    })
}

export function verifySsoEmail(formData) {
  return UsersApi.verifySsoEmail(formData)
    .then((res) => {
      if (res.response.ok) {
        return res.json
      }
    })
    .catch((error) => {
      throw error
    })
}

export function logOutUser(message = null) {
  if (localStorage.main_jwt) {
    localStorage.setItem('jwt', localStorage.main_jwt)
    localStorage.removeItem('main_jwt')
    localStorage.setItem('reload_message', message)
    window.location = '/'
  } else {
    localStorage.removeItem('jwt')
    mst.auth.reduxLogOutUser()
    if (message) {
      mst.alertMessages.showAlert(message)
    }
  }
}

export function assignFullStoryId(user) {
  if (process.env.NODE_ENV !== 'production') return

  user = User(user)
  const { role, host, guest, domain, stateLevel } = user
  window.fsIdentify(user.id, {
    email: user.email,
    displayName: user.fullName,
    role,
    host,
    guest,
    domain,
    stateLevel
  })
}

export function loggedInBootIntercom(user) {
  // Intercom disabled — re-enable when OOH decides on customer messaging tool
  return
}
